/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Asset_Page_Market_Snapshot_TitleInputs */

const en_asset_page_market_snapshot_title = /** @type {(inputs: Asset_Page_Market_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Market overview`)
};

const de_asset_page_market_snapshot_title = /** @type {(inputs: Asset_Page_Market_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktüberblick`)
};

const pt_br2_asset_page_market_snapshot_title = /** @type {(inputs: Asset_Page_Market_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão geral do mercado`)
};

const tr_asset_page_market_snapshot_title = /** @type {(inputs: Asset_Page_Market_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piyasa görünümü`)
};

const zh_cn2_asset_page_market_snapshot_title = /** @type {(inputs: Asset_Page_Market_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市场概况`)
};

const zh_hk2_asset_page_market_snapshot_title = /** @type {(inputs: Asset_Page_Market_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市場概況`)
};

const ko_kr2_asset_page_market_snapshot_title = /** @type {(inputs: Asset_Page_Market_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시장개요`)
};

const ru_ru2_asset_page_market_snapshot_title = /** @type {(inputs: Asset_Page_Market_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор рынка`)
};

const es_419_asset_page_market_snapshot_title = /** @type {(inputs: Asset_Page_Market_Snapshot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panorama del mercado`)
};

/**
* | output |
* | --- |
* | "Market overview" |
*
* @param {Asset_Page_Market_Snapshot_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const asset_page_market_snapshot_title = /** @type {((inputs?: Asset_Page_Market_Snapshot_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Asset_Page_Market_Snapshot_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_asset_page_market_snapshot_title(inputs)
	if (locale === "de") return de_asset_page_market_snapshot_title(inputs)
	if (locale === "pt-BR") return pt_br2_asset_page_market_snapshot_title(inputs)
	if (locale === "tr") return tr_asset_page_market_snapshot_title(inputs)
	if (locale === "zh-CN") return zh_cn2_asset_page_market_snapshot_title(inputs)
	if (locale === "zh-HK") return zh_hk2_asset_page_market_snapshot_title(inputs)
	if (locale === "ko-KR") return ko_kr2_asset_page_market_snapshot_title(inputs)
	if (locale === "ru-RU") return ru_ru2_asset_page_market_snapshot_title(inputs)
	return es_419_asset_page_market_snapshot_title(inputs)
});